// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609170405/js/" + chunkId + "." + {"44":"6e94a430","225":"d5e65e4b","481":"b1c8b3d6","486":"2e8284d0","770":"d2cb4e7e"}[chunkId] + ".0.6680556880183358.chunk.js";
};